export type StatusTone = 'ok' | 'warn' | 'error' | 'idle';

/**
 * A status indicator.
 *
 * The label is always rendered as text. The prompt's accessibility rules are
 * explicit — "do not communicate status using color alone" — so the colour and
 * the dot are reinforcement, and the dot is marked decorative so a screen
 * reader announces the label once, not twice.
 */
export function StatusPill({
  tone,
  label,
}: {
  tone: StatusTone;
  label: string;
}): React.JSX.Element {
  return (
    <span className={`status status--${tone}`}>
      <span className="status__dot" aria-hidden="true" />
      {label}
    </span>
  );
}
